import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { ExternalCostDto, ExternalCostAllocationDto } from '@api/client';

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const exportOtherCostsToExcel = (
  costs: ExternalCostDto[] | null | undefined,
  fileName = 'other-costs',
) => {
  const rows = costs || [];
  const monthKeys = new Map<string, { anno: number; mese: number }>();
  rows.forEach((row) => {
    (row.costAllocation || []).forEach((a: ExternalCostAllocationDto) => {
      if (a.anno != null && a.mese != null) {
        const key = `${a.anno}-${String(a.mese).padStart(2, '0')}`;
        if (!monthKeys.has(key)) monthKeys.set(key, { anno: a.anno, mese: a.mese });
      }
    });
  });
  const sortedMonths = Array.from(monthKeys.entries()).sort(([a], [b]) => a.localeCompare(b));

  const data = rows.map((row) => {
    const base: Record<string, string | number | undefined> = {
      Descrizione: row.description ?? '',
      'Tipo costo': row.costType?.description ?? '',
      'Contract amount': row.contractAmount,
      'Total bills ricevute': row.totalBillsRicevute,
    };
    sortedMonths.forEach(([, { anno, mese }]) => {
      const alloc = (row.costAllocation || []).find((a) => a.anno === anno && a.mese === mese);
      const label = `${MONTH_LABELS[mese - 1]} ${anno}`;
      base[label] = alloc?.actualCost ?? alloc?.extimatedCost ?? 0;
    });
    return base;
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Other costs');
  const buf = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
};
